import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as a, renderSlot as V, createElementVNode as n, createCommentVNode as v } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconIntersection"
}, b = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = g(s);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      V(i.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", m, t[0] || (t[0] = [
        n("path", { d: "M212,120v80a12,12,0,0,1-24,0V120a60,60,0,0,0-120,0v80a12,12,0,0,1-24,0V120a84,84,0,0,1,168,0Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M200,120v80H56V120a72,72,0,0,1,144,0Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,120v80a8,8,0,0,1-16,0V120a64,64,0,0,0-128,0v80a8,8,0,0,1-16,0V120a80,80,0,0,1,160,0Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,176a8,8,0,0,1-16,0V120a40,40,0,0,0-80,0v56a8,8,0,0,1-16,0V120a56,56,0,0,1,112,0Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", M, t[3] || (t[3] = [
        n("path", { d: "M206,120v80a6,6,0,0,1-12,0V120a66,66,0,0,0-132,0v80a6,6,0,0,1-12,0V120a78,78,0,0,1,156,0Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", Z, t[4] || (t[4] = [
        n("path", { d: "M208,120v80a8,8,0,0,1-16,0V120a64,64,0,0,0-128,0v80a8,8,0,0,1-16,0V120a80,80,0,0,1,160,0Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        n("path", { d: "M204,120v80a4,4,0,0,1-8,0V120a68,68,0,0,0-136,0v80a4,4,0,0,1-8,0V120a76,76,0,0,1,152,0Z" }, null, -1)
      ]))) : v("", !0)
    ], 16));
  }
});
export {
  b as default
};
